import React from 'react';
import Header from '../../components/header/index';
import Footer from '../../components/footer/index';
import { Row, Col, Pagination, Empty } from 'antd';
import { Link } from "react-router-dom";
import http from '../../http/http';
import './index.css';
import { connect } from 'react-redux';
import news_link_icon from '../../static/imgs/news_link_icon.png';
import news_placeholder from '../../static/imgs/news_placeholder.png';

class Trends extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 12,//每页显示条数
      pageNo: 1,
      trendsData: [],
      totalCnt: 0
    }
  }
  componentDidMount () {
    if (!this.props.news_info_data || !Object.keys(this.props.news_info_data).length) {
      this.requestList((dataArr) => {
        let resultArr = [];
        for (let i = 0; i < dataArr.length; i++) {
          let map = dataArr[i];
          resultArr.push({
            title: map.title,
            time: map.sendTime,
            message: map.desc,
            src: http.hostUrl + http.contextName + map.imgPath,
            id: map.id
          });
          // for (let i = 0; i < 23; i++) {
          //   resultArr.push({
          //     title: map.title,
          //     time: map.sendTime,
          //     message: map.content,
          //     src: http.hostUrl + http.contextName + "/resource/news/" + map.id + "/" + map.imgPath,
          //     id: map.id
          //   });
          // }
        }
        this.setState({
          trendsData: resultArr
        });
      });
    } else {
      let dataArr = this.props.news_info_data.data;
      let resultArr = [];
      for (let i = 0; i < dataArr.length; i++) {
        let map = dataArr[i];
        resultArr.push({
          title: map.title,
          time: map.sendTime,
          message: map.desc,
          src: http.hostUrl + http.contextName + map.imgPath,
          id: map.id
        });
      }
      this.setState({
        trendsData: resultArr,
        totalCnt: this.props.news_info_data.totalCnt
      });
    }
  }
  requestList (callback) {
    http.get("/public/api/news/list", {
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize
    }, response => {
      if (response && response.result) {
        let dataArr = response.result.data;
        this.props.SAVE_NEWS_INFO_DATA(response.result);
        this.setState({
          totalCnt: response.result.totalCnt
        });
        if (dataArr && dataArr.length) {
          callback(dataArr);
        }
      }
    });
  }
  render () {
    let contentItem = (
      <div className="trends_content">
        <Row gutter={[16, 16]} className="content_item box-padding-horizontal-news">
          {
            this.state.trendsData.map((data, index) => {
              return (
                <Col md={8} xs={24} sm={12} lg={8} xl={6} key={"trends_message_item_" + index}>
                  <div className="col">
                    <div className="trends_message_item">
                      <Link className="link" to={"/trendinfo/" + data.id}></Link>
                      <div className="img_bg">
                        <img className="img" src={data.src} onError={(e) => { e.target.src = news_placeholder }}></img>
                      </div>
                      <div className="title">{data.title}</div>
                      <div className="message">{data.message}</div>
                      <div className="bottom">
                        <div className="time">{this.formatDate(data.time)}</div>
                        <div className="xq">查看详情</div>
                        <img className="icon" src={news_link_icon}></img>
                      </div>
                    </div>
                  </div>
                </Col>
              )
            })
          }
        </Row>
        <Pagination defaultCurrent={1} total={this.state.totalCnt} pageSize={this.state.pageSize} style={{ marginTop: "30px" }} onChange={this.paginationOnChange.bind(this)}></Pagination>
      </div>
    )
    if (!this.state.trendsData.length) {
      contentItem = (
        <Empty description="暂无数据" style={{ color: "var(--light_text_color)" }}></Empty>
      )
    }
    return (
      <div className='index_wrap noscrollbar' style={{ width: "100%", height: "100%", position: "absolute", left: "0px", top: "0px" }}>
        <div>
          <Header index="3"></Header>
          <div className="box-padding-vertical">
            <div className="title_item box-padding-horizontal">
              <div className="title l_text">全部动态</div>
            </div>
            {
              contentItem
            }
          </div>
          <Footer></Footer>
        </div>
      </div>
    );
  }
  paginationOnChange (page, pageSize) {
    console.log(page + " " + pageSize);
    this.setState({
      pageNo: page
    }, () => {
      this.requestList((dataArr) => {
        let resultArr = [];
        for (let i = 0; i < dataArr.length; i++) {
          let map = dataArr[i];
          resultArr.push({
            title: map.title,
            time: map.sendTime,
            message: map.content,
            src: http.hostUrl + http.contextName + map.imgPath,
            id: map.id
          });
        }
        this.setState({
          trendsData: resultArr
        });
      });
    });
  }
  formatDate (dateStr) {
    let dateStrArr = dateStr.split(" ");
    let datetime = "";
    if (dateStrArr && dateStrArr.length > 1) {
      datetime = dateStrArr[0];
    }
    return datetime;
  }
}
function mapStateToProps (state) {
  return {
    news_info_data: state.news_info_data
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    SAVE_NEWS_INFO_DATA: (data) => {
      dispatch({ type: 'SAVE_NEWS_INFO_DATA', news_info_data: data })
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Trends);